import { useSite } from "../hooks/useSite";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { Accommodations } from "../components/site/Accommodations";
import { Gallery } from "../components/site/Gallery";
import { Services } from "../components/site/Services";
import { Location } from "../components/site/Location";
import { Contact } from "../components/site/Contact";
import { Footer } from "../components/site/Footer";
import { WhatsAppFloat } from "../components/site/WhatsAppFloat";
import { Seo } from "../components/site/Seo";
import { PreviewBanner, SiteLoader } from "../components/site/Misc";

export default function Home() {
  const { data, error } = useSite();
  if (error) return <div className="min-h-screen grid place-items-center text-zinc-400 px-6 text-center" data-testid="site-error">Não foi possível carregar o site. Tente novamente em instantes.</div>;
  if (!data) return <SiteLoader />;
  const c = data.content;
  return (
    <div className="bg-[#000000] text-zinc-100" data-testid="home-page">
      <Seo content={c} image={data.banner?.src} />
      <Header content={c} hasServices={(c.services || []).length > 0} />
      <PreviewBanner />
      <main>
        <Hero content={c} banner={data.banner} />
        <Accommodations content={c} rooms={data.accommodations} />
        <Gallery content={c} photos={data.gallery} />
        <Services content={c} />
        <Location content={c} />
        <Contact content={c} />
      </main>
      <Footer content={c} />
      <WhatsAppFloat content={c} />
    </div>
  );
}
